let level2Headings = document.querySelectorAll('.page-content > h2');
const summary = document.querySelector('.frge-summary');
const header = document.querySelector('.header__top')
const summaryDropDownMenu = document.querySelector('.summary-dropdown__menu');
const selectedHeading = document.querySelector('#summary-dropdown__selected-heading');
const summaryDropDown = document.querySelector('.summary-dropdown');
const summaryDropDownIcon = document.querySelector('.summary-dropdown__icon');

if (document.querySelector('.funders-container')) {
    level2Headings = document.querySelectorAll('.page-content > h2, .funders-container > h2');
}

if (summary && level2Headings.length > 0) {
    summary.style.top = `${header.offsetHeight}px`;
    //Pour tout les h2 on créer un id unique 
    //on créer des options dans le select avec le texte du h2 et un lien vers le h2
    level2Headings.forEach((heading, index) => {
        heading.id = heading.textContent.toLowerCase().replace(/ /g, '-');
        //On enlève les caractères spéciaux et le dernier tiret
        heading.id = heading.id.replace(/[^\w-]+/g, '');
        heading.id = heading.id.replace(/-$/, '');
        heading.id += `-${index}`;
        //on ajoute un index à l'id si jamais il y a 2 h2 avec le même texte

        //On créer un lien vers le h2
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;

        summaryDropDownMenu.appendChild(link);
    });


    //Selon le scroll dans la page si on est sur un h2 on le texte du h2 dans le summary avec un lien vers le h2
    window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY;
        level2Headings.forEach(heading => {
            const headingPosition = heading.getBoundingClientRect().top;
            const offsetHeadingPosition = headingPosition + scrollPosition;
            const headerImg = document.querySelector('.page-template__main-img');
            const pageContentContainer = document.querySelector('.page-content');
            if (headerImg) {
                if (scrollPosition >= header.offsetHeight + headerImg.offsetHeight) {
                    summary.style.display = 'block';
                } else {
                    summary.style.display = 'none';
                }
            } else {
                if (scrollPosition >= header.offsetHeight) {
                    summary.style.display = 'block';
                } else {
                    summary.style.display = 'none';
                }
            }


            if (pageContentContainer.getBoundingClientRect().bottom <= 0 + header.offsetHeight) {
                summary.style.display = 'none';
            }

            if (scrollPosition >= offsetHeadingPosition - header.offsetHeight - 50) {
                selectedHeading.innerHTML = `${heading.textContent} `;
            }
        });
    });

    //Si on clique sur le summary on affiche le dropdown
    summary.addEventListener('click', () => {
        summaryDropDownMenu.classList.toggle('is-open');
        summaryDropDownIcon.classList.toggle('is-open');
    });
}